import React from "react";

// Image \\
import hospitalAvatar from "../../assets/images/aboutUs.svg";

// Style \\
import "../../assets/styles/sections/practise.scss";

const Practise = () => {
  return (
    <section className="practice">
      <div className="container">
        <div className="practice_items">
          <div className="practice_items_image">
            <img src={hospitalAvatar} alt="" />
          </div>

          <div className="practice_items_text">
            <div className="title">
              <p>About My Practice</p>
              <h3>
                Best Care for Your <br /> Good Health
              </h3>
            </div>

            <div className="practice_sections">
              <div className="oneCol">
                <div className="part">
                  <div className="round"></div>
                  <p>A Passion for Healing</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>All our best</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>Always Caring</p>
                </div>
              </div>

              <div className="oneCol">
                <div className="part">
                  <div className="round"></div>
                  <p>5-Star Care</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>Believe in Us</p>
                </div>
                <div className="part">
                  <div className="round"></div>
                  <p>A Legacy of Excellence</p>
                </div>
              </div>
            </div>

            <div className="text">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Quisque placerat
                scelerisque tortor ornare ornare Convallis felis vitae tortor
                augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque. Convallis felis vitae tortor augue. Velit
                nascetur proin massa in.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Practise;
